import React from "react";
import Rollbar from '../utils/RollbarTracking'
import Select from 'react-select';
import axios from 'axios'
import { toast } from 'react-toastify';

export class SelectCategories extends React.Component {

  constructor(props)  {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
      categories: [],
      selectedCategories: []
  }

  componentWillMount() {
    this.fetchCategories()
    if (this.props.filter) {
        this.setState({selectedCategories: this.props.filter})
    }
  }

  handleChange(evt) {
    this.setState({selectedCategories: evt})
    this.props.updateParameters({filter: evt})
  }

  fetchCategories = async () => {
    axios.get('/categories')
        .then(data => {
            console.log(data);
            this.setState({
                categories: data
            });
        })
        .catch (err => {
          console.log(err);
          Rollbar.error(err)
          toast.error('Failed to fetch categories')
        })
  }

  render() {
    return (
        <Select
            isMulti
            name="categories"
            options={this.state.categories}
            value={this.state.selectedCategories}
            onChange={this.handleChange}
            getOptionLabel={(option)=>option.name}
            getOptionValue={(option)=>option.categoryID}
        />
    );
  }
}